export const ApplicationRealtimeUsersModule = {
  state: () => ({
    realTimeUsers: null,
    loading: false,
    fetched: false,
  }),
  mutations: {
    updateData(state, res) {
      state.realTimeUsers = res.realtime_users
    },
    clearData(state) {
      state.realTimeUsers = null
      state.loading = false
      state.fetched = false
    },
    setLoading(state, value) {
      state.loading = value
    },
    setFetched(state, value) {
      state.fetched = value
    },
  },
  actions: {
    async loadAppEventsData({ commit, rootState }) {
      commit('setLoading', true)
      const result = await fetch(
        process.env.VUE_APP_API_HOST + `/v1/charts/realtime`,
        {
          headers: {
            Authorization: `Bearer ${rootState.AuthModule.token}`,
          },
        },
      ).then((res) => {
        commit('setLoading', false)
        return res.json()
      })
      commit('updateData', result)
      commit('setFetched', true)
    },
    logout({ commit }) {
      commit('clearData')
    },
  },
}
